<template>
  <div>
    <div id="created-tokens" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      <vs-sidebar
        class="items-no-padding"
        parent="#created-tokens"
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="isChatSidebarActive"
        id="chat-list-sidebar"
      >
        <div class="chat__profile-search flex p-4">
          <vs-row>
            <vs-col
              class="px-0 order-last md:order-first mt-3 md:mt-0"
              vs-type="flex"
              vs-justify="center"
              vs-align="flex-end"
              :vs-lg="isGotu ? 6 : 12"
              vs-sm="12"
            >
              <vs-input
                v-model="searchUser"
                icon-no-border
                icon="icon-search"
                icon-pack="feather"
                class="w-full mx-3 input-rounded-full"
                :placeholder="$t(`ACCESTOKENS.searchUser`)"
              />
            </vs-col>

            <vs-col
              v-if="isGotu"
              class="px-0 companies order-first md:rder-last"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="6"
              vs-sm="12"
            >
              <vs-select
                autocomplete
                class="selectExample w-full rounded mx-3 md:mx-0"
                label="Seleccione compañía"
                v-model="idCompany"
                @change="
                  getUsers(idCompany);
                  keyOneUser = '';
                  tokenSuccess = '';
                "
              >
                <vs-select-item
                  :key="index"
                  :value="company.key"
                  :text="company.name"
                  v-for="(company, index) in listCompanies"
                />
              </vs-select>
            </vs-col>
          </vs-row>
          <feather-icon
            class="md:inline-flex lg:hidden -ml-3 cursor-pointer"
            icon="XIcon"
            @click="toggleChatSidebar(false)"
          />
        </div>

        <vs-divider class="d-theme-border-grey-light m-0" />
        <component :is="scrollbarTag" class="chat-scroll-area pt-4 bg-withe" :settings="settings" :key="$vs.rtl">
          <div class="chat__contacts mb-5">
            <div class="flex justify-between items-center">
              <h3 class="text-primary mb-5 px-4">{{$t(`ACCESTOKENS.users`)}}</h3>
            </div>
            <ul class="chat__contacts bordered-items">
              <li class="cursor-pointer" v-for="user in _MapUsers" :key="user.key">
                <chat-contact
                  :key="user.key"
                  :user="user"
                  @addToSelected="
                    keyOneUser = $event;
                    tokenSuccess = '';
                  "
                ></chat-contact>
              </li>
            </ul>
          </div>
        </component>
      </vs-sidebar>

      <div
        class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
        :class="{ 'sidebar-spacer--wide': clickNotClose }"
      >
        <div class="w-full p-5" style="height: 93%">
          <div class="w-full h-full bg-white rounded p-3 overflow-y-auto">
            <div class="flex justify-between px-2">
              <feather-icon
                class="md:-flex lg:hidden -ml-3 cursor-pointer"
                icon="ArrowLeftIcon"
                @click="toggleChatSidebar(true)"
              />
              <h4>{{$t(`ACCESTOKENS.newTokens`)}}</h4>
            </div>
            <vs-divider />
            <vs-row>
              <vs-col class="px-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12">
                <div class="w-full">
                  <label class="vs-input--label">{{$t(`ACCESTOKENS.dateEspirated`)}}</label>
                  <datepicker
                    :disabledDates="disabledDates"
                    :language="lang['es']"
                    :format="format"
                    placeholder="Seleccione Fecha"
                    v-model="expireAccount"
                    rules="'required'"
                    name="expireAccount"
                  ></datepicker>
                </div>
              </vs-col>
              <vs-col class="px-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12">
                <vs-input
                  :label="$t(`ACCESTOKENS.user`)"
                  disabled
                  class="inputx w-full"
                  :value="`${_getOneUser.name} ${_getOneUser.lastname}`"
                />
              </vs-col>
            </vs-row>

            <vs-row class="mt-2">
              <vs-col class="px-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12">
                <vs-input :label="$t(`ACCESTOKENS.company`)" disabled class="inputx w-full" :value="`${_getOneUser.companyName}`" />
              </vs-col>
              <vs-col class="px-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12">
                <vs-input :label="$t(`ACCESTOKENS.phone`)" disabled class="inputx w-full" :value="`${_getOneUser.cellPhone}`" />
              </vs-col>
            </vs-row>

            <vs-row class="mt-2">
              <vs-col class="px-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12">
                <vs-input :label="$t(`ACCESTOKENS.Email`)" disabled class="inputx w-full" :value="`${_getOneUser.email}`" />
              </vs-col>
              <vs-col class="px-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12">
                <vs-input :label="$t(`ACCESTOKENS.Role`)" disabled class="inputx w-full" :value="`${_getOneUser.roleName}`" />
              </vs-col>
            </vs-row>

            <vs-row class="mt-0 md:mt-5 pb-6 md:pb-0" vs-type="flex" vs-justify="between">
              <vs-col class="px-2 mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="12">
                <div v-if="!accessTokenCreated">
                  <span class="inline-block w-full font-bold mb-1"> Api token creado: </span>
                  <label class="text-success inline-block w-full"> {{ tokenSuccess }} </label>
                </div>
              </vs-col>
              <vs-col class="px-2 mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
                <vs-button
                  v-if="accessTokenCreated"
                  :disabled="btn_disbled"
                  class="w-full"
                  color="success"
                  type="border"
                  @click="createToken"
                  >{{$t(`ACCESTOKENS.createToken`)}}</vs-button
                >
                <vs-button v-else class="w-full" color="success" type="border" @click="clear">{{$t(`ACCESTOKENS.new`)}}</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import createTokens from "./mixins/createTokens";

import chatContact from "./components/ChatContact.vue";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import moment from "moment";
import { loading, closeLoding } from "@/helpers/$vs";

export default {
  mixins: [createTokens],
  components: { VuePerfectScrollbar, chatContact, Datepicker },
  data() {
    return {
      searchUser: "",
      lang,
      format: "dd MMMM yyyy",
      expireAccount: moment().add(7, "days").toDate(),
      isChatSidebarActive: false,
      isSidebarActive: false,
      clickNotClose: false,
      disabledDates: {
        to: moment().add(7, "days").toDate(),
        from: moment().add(14, "days").toDate()
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      }
    };
  },
  methods: {
    toggleChatSidebar(value) {
      if (!value && this.clickNotClose) return;
      this.isChatSidebarActive = value;
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = true;
        this.clickNotClose = false;
      } else {
        this.isChatSidebarActive = true;
        this.clickNotClose = true;
      }
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth();
    }
  },
  async mounted() {
    loading();
    const idCompany = this.$store.state.user.companyID;
    await this.getUsers(idCompany, false);
    await this.getAllCompanies();
    this.idCompany = this.$store.state.user.companyID;
    closeLoding();
  },
  created() {
    this.setSidebarWidth();
  }
};
</script>

<style lang="scss">
// @import "@/assets/scss/vuexy/apps/chat.scss";
@import "./createToken.scss";

#created-tokens .companies .con-select .vs-select--input {
  border-radius: 50px !important;
}
</style>
